import { Component, OnInit, OnDestroy } from '@angular/core';
import User from '../../../interfaces/User';
import { Subscription, Observable } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { Location } from '@angular/common';
import { UploadService } from 'src/app/services/upload.service';
import { ToastService } from 'src/app/services/toast.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ParamMap, ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { UrlService } from 'src/app/services/url.service';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit, OnDestroy {
  formData: User;
  inputs = {
    bio: { isFocused: false, inputValue: '' },
    email: { isFocused: false, inputValue: '' },
    expertise: { isFocused: false, inputValue: [] },
    firstName: { isFocused: false, inputValue: '' },
    jobTitle: { isFocused: false, inputValue: '' },
    lastName: { isFocused: false, inputValue: '' },
    profilePicture: { isFocused: false, inputValue: '' },
    title: { isFocused: false, inputValue: '' },
    webpage: { isFocused: false, inputValue: '' },
  };
  editorModules = {
    toolbar: [['link', 'bold', 'italic', 'underline', 'strike', 'blockquote', { list: 'ordered' }, { list: 'bullet' }]],
  };
  tags = {
    standard: [
      'technology',
      'environmental-impacts',
      'governance',
      'markets-finance',
      'funding',
      'cdr-community',
      'social-licensing',
    ],
    approaches: ['microalgae', 'blue-carbon', 'macroalgal','alkalinity', 'co2-removal', 'storage', 'other'],
  };
  subscriptions: Subscription = new Subscription();
  user$: Observable<any>;
  user: User;
  previewFile;
  attachmentFile;

  constructor(
    private userService: UserService,
    private location: Location,
    private uploadService: UploadService,
    private toastService: ToastService,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private urlService: UrlService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['id']) {
        this.userService.getUser(params['id']).then((m: any)=>{
          this.user = m;
        })
      } else {
        this.subscriptions.add(
          this.userService.user.subscribe((u) => {
            if (u && u.uid) {
              this.user = u;

              // Pre-fill first and last name after user signs up
              const namesArr = this.user.displayName.split(' ');
              if (!this.user.firstName || (namesArr.length > 1 && !this.user.lastName)) {
                this.user.firstName = namesArr[0];
                this.user.lastName = namesArr[1];
              }
              // Init expertise array if empty
              if (!this.user.expertise) {
                this.user.expertise = [];
              }
            }
          })
        );
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  onFileChanged(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      var t = this;
      reader.onload = function (e) {
        t.previewFile = reader.result;
      };

      reader.readAsDataURL(event.target.files[0]); // convert to base64 string

      this.attachmentFile = event.target.files[0];
    }
  }

  removePhoto() {
    this.previewFile = null;
    this.attachmentFile = null;
    this.user.profilePicture = null;
  }

  toggleTag(t) {
    const tags = this.user.expertise;
    if (tags.indexOf(t) === -1) {
      tags.push(t);
    } else {
      tags.splice(tags.indexOf(t), 1);
    }
  }

  saveProfile() {
    this.loadingService.startLoading();
    if (this.user.bio) {
      this.user.bio = this.urlService.processContent(this.user.bio);
    }
    if (this.attachmentFile) {
      this.uploadService.uploadFile(this.attachmentFile).then((downloadUrl) => {
        this.user.profilePicture = downloadUrl;
        this.saveUser();
      });
    } else {
      this.saveUser();
    }
  }

  saveUser() {
    this.userService.saveUser(this.user.uid, this.user).then(() => {
      this.loadingService.stopLoading();
      this.toastService.setToast('<p class="mbn txt-c">Your profile was updated</p>');
      this.location.back();
    });
  }

}

// bio: string;
// country: string;
// discussionStats: any;
// displayName: string;
// documentStats: any;
// email: string;
// expertise: any;
// events: Event;
// firstName: string;
// following: Array<any>;
// institutions: Institutions;
// interests: Array<any>;
// jobTitle: string;
// jobSector: string;
// lastName: string;
// notificationSettings: any;
// profilePicture: string;
// projects: Projects;
// role: string;
// title: string;
// uid: string;
// webpage: string;
